// extracted by mini-css-extract-plugin
export default {"desktop":"style_desktop__qKMaB","mobile":"style_mobile__kmbd8","laptop":"style_laptop__J3O21"};